<p-tabView
  [activeIndex]="activeSubComponent"
  (onChange)="onTabActivated($event)"
  styleClass="bfx-tabview"
>
  <p-tabPanel header="Preferences" styleClass="user-settings-tab-panel">
    <bfx-trade-blotter-settings-preferences #subComponent> </bfx-trade-blotter-settings-preferences>
  </p-tabPanel>
</p-tabView>
